module.exports = __webpack_public_path__ + "img/lizailing.ab938047.png";